import { render, staticRenderFns } from "./EjectionsPage.vue?vue&type=template&id=36d452e2&scoped=true"
import script from "./EjectionsPage.vue?vue&type=script&lang=js"
export * from "./EjectionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d452e2",
  null
  
)

export default component.exports